import React from 'react';

export function Section({
  fluid = false,
  pad = true,
  className = '',
  children,
  ...props
}) {
  return (
    <div
      className={`${!fluid ? 'tw-m-auto section tw-px-4' : ''} ${pad ? 'tw-py-8 md:tw-py-16 lg:tw-py-20' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
